// extracted by mini-css-extract-plugin
export default {"container":"DismissableAlert_container__EuoSt","light":"DismissableAlert_light__JS2r4","message":"DismissableAlert_message__2PaZG"};